import Clipboard from 'clipboard';

// Preserve $copyText's Promise and event payload, including HTTP and modal use.
export function copyText(text, container = document.body) {
  return new Promise((resolve, reject) => {
    const button = document.createElement('button');
    const clipboard = new Clipboard(button, {
      text: () => text,
      action: () => 'copy',
      container,
    });
    const finish = (callback) => (event) => {
      clipboard.destroy();
      callback(event);
    };
    clipboard.on('success', finish(resolve));
    clipboard.on('error', finish(reject));
    document.body.appendChild(button);
    button.click();
    button.remove();
  });
}

export default {
  install(app) {
    app.config.globalProperties.$copyText = copyText;
  },
};
